<template>
  <router-view :con="con"/>
</template>

<script>
import  { request } from '@/assets/js/requests.js';
export default {
    name:"appGeneral",
    data(){
        return{
            con:new request('https://noisy.efisense.xyz'),
        }
    }
}
</script>

<style lang="css">
#app {
  position: relative;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: var(--primaryText);
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  align-items: flex-start;
}
</style>
